/*!

=========================================================
* Paper Kit React - v1.3.2
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
routessss
*/
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Navigate, Routes } from "react-router-dom";
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n'; // Import the i18n configuration
import Logo from "components/Headers/Logo";
// styles
import "bootstrap/scss/bootstrap.scss";
import "assets/scss/paper-kit.scss?v=1.3.0";
import "assets/demo/demo.css?v=1.3.0";
// pages
import Index from "views/Index.js";
import NucleoIcons from "views/NucleoIcons.js";
import LandingPage from "views/examples/LandingPage.js";
import ProfilePage from "views/examples/ProfilePage.js";
import RegisterPage from "views/examples/RegisterPage.js";
import CreditSweeps from "components/pages/CreditSweeps";
import Packages from "components/pages/Packages";
import InquiryRemoval from "components/pages/InquiryRemoval.js";
// import Business from "components/pages/Business"; removing business credit for now
import SupportTicket from "components/pages/SupportTicket";
import FAQ from "components/pages/FAQ";
import Inventory from "components/pages/Inventory";
import { LanguageProvider } from './LanguageContext';

import Test from "components/pages/Test";
// others

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <LanguageProvider>
      <BrowserRouter>
          <Routes>
            <Route path="/index" element={<Index />} />
            <Route path="/nucleo-icons" element={<NucleoIcons />} />
            <Route path="/creditsweeps" element={<CreditSweeps />} />
            <Route path="/inquiryremoval" element={<InquiryRemoval />} />
            <Route path="/packages" element={<Packages />} />
            {/* <Route path="/business" element={<Business />} /> */}
            <Route path="/FAQ" element={<FAQ />} />
            <Route path="/support" element={<SupportTicket />} />
            <Route path="/inventory" element={<Inventory />} />
            <Route path="/landing-page" element={<LandingPage />} />
            <Route path="/profile-page" element={<ProfilePage />} />
            <Route path="/register-page" element={<RegisterPage />} />
            <Route path="*" element={<Navigate to="/index" replace />} />
          </Routes>
        </BrowserRouter>
    </LanguageProvider>

  </React.StrictMode>
);
